import {useCallback, useContext, useMemo} from 'react';

import {MainFilterContext} from '../../../../../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../../../../../provider/main-filter/main-filter-type';
import {useReviewCityList} from '../../../../../../service/reivew-analysis/review-cities/review-cities-hook';
import {
    ReviewCityListQueryType,
    ReviewCityType,
} from '../../../../../../service/reivew-analysis/review-cities/review-cities-type';
import {ReviewsAndAnswersStatisticsUnitMeasurementEnum} from '../../../../../../service/reviews-and-answers-statistics/reviews-and-answers-statistics';
import {useTableSorter} from '../../../../../../util/antd/table/table-sorter-hook';
import {useReviewsAnalysisFilter} from '../../../reviews-analysis-hook';
import {citiesDefaultPageSize} from '../cities-page-const';
import {getCitiesTableSorterQueryValue} from '../cities-page-helper';
import {CityTableDataType} from '../cities-page-type';
import {CitiesTable} from '../cities-table/cities-table';

export function CitiesTableSingle(): JSX.Element | null {
    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    const {singleFilter} = useReviewsAnalysisFilter();

    const {sorterQueryValue, setSorterOrder, getSortOrder} = useTableSorter({
        getSorterQueryValue: getCitiesTableSorterQueryValue,
    });

    const reviewCityListOptions: ReviewCityListQueryType = useMemo(() => {
        return {
            ...singleFilter,
        };
    }, [singleFilter]);

    const {result, isInProgress, processError, pagination} = useReviewCityList(
        reviewCityListOptions,
        sorterQueryValue,
        mainFilterKey,
        {
            initialPageSize: citiesDefaultPageSize,
        }
    );

    const getDataSource = useCallback((array: Array<ReviewCityType>, isForExport?: boolean) => {
        return array.map<CityTableDataType>(
            (dataItem: ReviewCityType, index): CityTableDataType => ({
                ...dataItem,
                key: `${dataItem.cityId} ${index} ${isForExport && 'export'}`,
            })
        );
    }, []);

    const dataSource: Array<CityTableDataType> = useMemo<Array<CityTableDataType>>(
        (): Array<CityTableDataType> => getDataSource(result?.results || []),
        [getDataSource, result?.results]
    );

    if (processError) {
        return null;
    }

    return (
        <CitiesTable
            dataSource={dataSource}
            getSortOrder={getSortOrder}
            isInProgress={isInProgress}
            pagination={pagination}
            setSortOrder={setSorterOrder}
            timeUnit={singleFilter.timeFormat || ReviewsAndAnswersStatisticsUnitMeasurementEnum.Minutes}
        />
    );
}
